import Component from './Component';

function CollectionBox(props) {
    return <Component {...props} />;
}

export default CollectionBox;
